// Private parent-realm bus. No DOM event/global bridge for untrusted frames.
const listeners = new Set<() => void>();

export function subscribePreviewActivity(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Call only after validating source, run ID, payload and the active frame. */
export function notifyPreviewActivity() {
  for (const listener of listeners) listener();
}
